<template>
  <div class="table-wrapper">
    <table class="custom-table">
      <thead class="table-header">
      <tr>
        <th class="text-left comment-col">Lời nhận xét</th>
        <th class="text-center action-col">Hành động</th>
      </tr>
      </thead>
    </table>

    <div class="table-body-wrapper">
      <table class="custom-table">
        <tbody>
        <tr
            v-for="(item, index) in criterion?.items"
            :key="index"
            class="table-row"
        >
          <td
              class="comment-cell"
              :class="selectedScore === item.score ? 'highlighted' : ''"
          >
            <span v-html="item.eComment||item.comment"></span>
          </td>
          <td class="action-cell">
            <div class="action-button-wrapper">
              <el-button
                  type="primary"
                  class="bg-header-color text-white"
                  @click="handleAutoMarkExam(item)"
              >
                Chọn
              </el-button>
            </div>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TableMarkBarem',
  props: {
    criterion: Object,
    selectedScore: Number
  },
  methods: {
    handleAutoMarkExam(item){
      this.$emit('select-item', item)
    }
  },
}
</script>

<style scoped>
.table-wrapper {
  border: 1px solid #d1d5db;
  border-radius: 6px;
  overflow: hidden;
}

.custom-table {
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;
}

.table-header {
  background-color: #e5e7eb;
}

.comment-col {
  text-align: left;
  padding: 8px;
  width: 80%;
}

.action-col {
  text-align: center;
  width: 20%;
}

.table-body-wrapper {
  max-height: 500px;
  overflow-y: auto;
}

.table-row {
  border-bottom: 1px solid #e5e7eb;
}

.comment-cell {
  padding: 8px;
  vertical-align: top;
  width: 80%;
}

.action-cell {
  width: 20%;
  padding: 8px;
}

.action-button-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
}

.highlighted {
  color: #3b82f6;
  font-weight: 600;
}
</style>